export default __webpack_public_path__ + "static/media/c1.ae8b118d.svg";